module.exports = __webpack_public_path__ + "static/media/no.b884cec9.svg";